.link {
  cursor: pointer;
  font-size: 15px;
}

.link--minimal {
  text-decoration: none;
}

@media all and (--reefer-media-tablet-min) {
  .link {
    font-size: 16px;
  }
}
